<template>
  <div id="app" class="wrapper">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="cart">
        <br />
        <h1 class="title cor-preta">Meus dados</h1>

        <div class="modal-body">
          <!--<form v-for="nome_ordem of nome_ordens" :key="nome_ordem.cd">-->
          <form>
            <div class="col-md-14">
              <div class="form-group">
                <label class="col-md-4 control-label" for="estado"
                  >Estado :
                </label>
                <div class="col-md-10">
                  <!--<input type="text" id="estado" name="estado" v-model="estado" placeholder="Estado" class="form-control input-md" required="required">-->
                  <select
                    class="form-control"
                    id="estado"
                    name="estado"
                    v-model="estado"
                  >
                    <option value="">Selecione o Estado (UF)</option>
                    <option v-for="(estado, idx) of estados" :key="idx">
                      {{ estado.uf }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="cidade"
                  >Cidade :
                </label>
                <div class="col-md-10">
                  <select
                    class="form-control"
                    id="cidade"
                    name="cidade"
                    v-model="cidade"
                    @change="getBairros(cidade.ibge)"
                  >
                    <option :value="cid" v-for="cid of cidades" :key="cid.cd">
                      {{ cid.nm }}
                    </option>
                  </select>
                </div>
              </div>

              <div
                class="form-group"
                v-if="cidade.nm != ''"
              >
                <label class="col-md-4 control-label" for="estado"
                  >Bairro :
                </label>
                <div class="col-md-10">
                  <select
                    class="form-control"
                    id="bairro"
                    name="bairro"
                    v-model="bairro"
                  >
                    <option :value="bai" v-for="bai of bairros" :key="bai.cd">
                      {{ bai.nm }}
                    </option>
                  </select>
                  <div
                    style="margin: 5px"
                    id="taxa"
                    name="taxa"
                    v-if="bairro.nm != ''"
                  >
                    <div>Taxa de entrega: R${{ bairro.taxa }}</div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="rua">Rua : </label>
                <div class="col-md-10">
                  <input
                    type="text"
                    id="rua"
                    name="rua"
                    v-model="rua"
                    placeholder="Rua"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="numero"
                  >Número :
                </label>
                <div class="col-md-10">
                  <input
                    type="number"
                    id="numero"
                    name="numero"
                    v-model="numero"
                    placeholder="Número"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="complemento"
                  >Complemento :
                </label>
                <div class="col-md-10">
                  <input
                    type="text"
                    id="complemento"
                    name="complemento"
                    v-model="complemento"
                    placeholder="Complemento"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="referencia"
                  >Referência :
                </label>
                <div class="col-md-10">
                  <input
                    type="text"
                    id="referencia"
                    name="referencia"
                    v-model="referencia"
                    placeholder="Referência"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            style="
              color: #fff;
              border-color: #343a40;
              background-color: #006400;
            "
            type="button"
            class="btn btn-dark"
            @click="cadastrarEndereco()"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style >
.form-control {
  padding: 0.25rem 0.25rem !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import Cardapio from "../services/cardapio";
import store from "../store/index.js";
import Adicional from "../services/adicional";
import Ordem from "../services/nome_ordem";
import Contrato from "../services/contrato";
import Venda from "../services/venda";
import Estado from "../services/estado";
import Endereco from "../services/endereco";
import ItemVenda from "../services/item_venda";
import Bairro from "../services/bairro";
import Cidade from "../services/cidade";
import Inis from "../services/inis";
import Swal from "sweetalert2";
import adicional from "../services/adicional";
import cidade from "../services/cidade";

export default {
  name: "Endereco",
  data() {
    return {
      msgEntrega: "",
      msgRetirada: "",
      msgBuscaFone: "",
      email: "",
      senha: "",
      nomecompleto: "",
      telefone: "",
      estado: "",
      cidade: {
        uf: "",
        nm: "",
        qtd_estab: "",
        ibge: "",
        dt_replica: "",
        hash: "",
      },
      bairro: {
        cd: "",
        nm: "",
        ibge: "",
        taxa: "",
        ativo: "",
        dt_replica: "",
      },
      rua: "",
      numero: "",
      complemento: "",
      referencia: "",
      ibge: "",
      inis_valores: [],
      inis_valor: [],
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      vendaspedidos: [],
      vendas: [],
      venda: {
        cd: "",
        total: "",
        dt: "",
        cd_usu: "",
        status: "",
        forma: "",
        troco: "",
        taxa: "",
        vl_desc: "",
      },
      bairroCidade: [],
      listarendereco: false,
      bairros: "",
      cidades: "",
      estados: "",
      listaAdicionais: "",
    };
  },
  computed: {
    ...mapGetters({
      //adicionais: 'allAdicionais',
      logado: "retornaLogado",
    }),
  },
  methods: {
    //listarinis
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis_valor = resposta.data;
      });
    },
    listandoCidade() {
      Cidade.listandoCidade().then((resposta) => {
        this.cidades = resposta.data;
        // alert(JSON.stringify(this.cidades));
      });
    },
    listandoEstado() {
      Estado.listandoEstado().then((resposta) => {
        this.estados = resposta.data;
        // alert(JSON.stringify(this.cidades));
      });
    },
    returnIBGE(ibge) {
      this.ibge = ibge;
    },

    async cadastrarEndereco() {
      if (this.estado == "") {
        Swal.fire({
          title: "Escolha um estado",
          confirmButtonColor: "#000000",
        });
      } else if (this.cidade.nm == "") {
        Swal.fire({
          title: "Escolha uma cidade",
          confirmButtonColor: "#000000",
        });
      } else if (this.bairro.nm == "") {
        Swal.fire({
          title: "Escolha uma bairro",
          confirmButtonColor: "#000000",
        });
      } else if (this.rua == "") {
        Swal.fire({
          title: "Digite sua rua",
          confirmButtonColor: "#000000",
        });
      } else if (this.numero == "") {
        Swal.fire({
          title: "Digite seu número de endereço",
          confirmButtonColor: "#000000",
        });
      } else {
        var e = new Object();
        e.estado = this.estado;
        e.cidade = this.cidade.nm;
        e.bairro = this.bairro.nm;
        e.rua = this.rua + ", n" + this.numero;
        e.complemento = this.complemento;
        e.referencia = this.referencia;
        e.ibge = this.ibge;
        e.cd = localStorage.getItem("cd" + localStorage.getItem("contrato"));

        await Endereco.cadastrarendereco(e).then(function (response) {
          Swal.fire({
            title: response.data,
            confirmButtonColor: "#000000",
          });
        });

        this.$router.push("/finalizadoLogin");
      }
    },
    getBairros(cidade) {
      Bairro.listandoBairro(cidade).then((response) => {
        this.bairros = response.data.map((bairro) => {
          bairro.taxa = parseFloat(bairro.taxa).toFixed(2);
          return bairro;
        });
      });
    },
    verificaLogado() {
      if (this.logado == false) {
        this.$router.push("/login");
      }
    },
  },
  mounted() {
    this.verificaLogado();
    this.listarinis();
    this.listandoCidade(), this.listandoEstado();
  },
};
</script>